'use strict';

angular.module('amexReconciliationApp')
  .component('accountingManagerAccountsList', {
    templateUrl: 'scripts/views/components/accounting-manager-accounts-list.html',
    controller: function(TransactionSearchModel,
                         AccountListService,
                         BillingCycleModel,
                         AccountingLineBillingCycleRepository,
                         PaginationModelFactory,
                         AccountingLineSortModel,
                         AccountingLineFilterModel,
                         $scope,
                         UserModel,
                         roles,
                         booleanConstants,
                         $state) {
      var self = this;
      var PAGE_SIZE = 20;
      var accountingPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

      self.loading = true;
      self.rowLoading = null;

      self.isSuperAdmin = UserModel.isSuperAdmin;

      self.roles = UserModel.roles();
      self.currentRole = TransactionSearchModel.role();

      self.onRoleChanged = function () {
        AccountListService.roleChange(self.currentRole);
      };

      AccountingLineSortModel.onAccountingLinesChanged($scope, function (accountingLineViews) {
        accountingPaginationModel.repaginate(accountingLineViews);
      });

      self.pageStart = accountingPaginationModel.pageStart;
      self.pageEnd = accountingPaginationModel.pageEnd;
      self.pageSize = accountingPaginationModel.pageSize;
      self.currentPage = accountingPaginationModel.pageNumber;
      self.totalCount = accountingPaginationModel.totalCount;
      self.showPagination = accountingPaginationModel.showPagination;
      self.updateCurrentPage = accountingPaginationModel.updateCurrentPage;
      self.accountingFilter = AccountingLineFilterModel.filter;
      self.accountingLineViews = [];
      self.booleanConstants = booleanConstants;

      var openedRow = null;

      self.$onInit = function() {
        AccountingLineBillingCycleRepository.findSummaries().then(function(accountingLineViews) {
          AccountingLineFilterModel.unfilteredAccountingLines(accountingLineViews);
        }).finally(function() {
          self.loading = false;
          if(self.accountingLineViews.length === 1) {
            self.toggleRow(0);
          }
        });
      };

      accountingPaginationModel.onRecordsOnCurrentPageChanged($scope, function () {
        self.accountingLineViews = accountingPaginationModel.recordsOnCurrentPage();
      });

      self.billingCycleStatus = function (billingCycle) {
        if(!billingCycle) { return ''; }

        if(billingCycle.cycleOpen) {
          return 'accountingManagerAccounts.BillingCycleOpen';
        } else {
          return 'accountingManagerAccounts.BillingCycleClosed';
        }
      };

      self.toggleRow = function (index) {
        var accountingLineView = self.accountingLineViews[index];

        if(accountingLineView.billingCycles.length === 0) { return; }

        if(openedRow === index) {
          openedRow = null;
        } else {
          self.rowLoading = index;
          self.accountingLineViews[index].billingCycles = self.accountingLineViews[index].billingCycles.slice(0,1);
          var accountingLine = accountingLineView.accountingLine;
          AccountingLineBillingCycleRepository
            .findAll(
              accountingLine.siteNumber,
              accountingLine.linkKey,
              accountingLine.concatValue
            ).then(function(billingCycles) {
              self.accountingLineViews[index].billingCycles = billingCycles;
              self.rowLoading = null;
            });
          openedRow = index;
        }
      };

      self.isRowOpen = function (index) {
        return openedRow === index;
      };

      self.rowspanForRow = function (index) {
        if(self.isRowOpen(index)) {
          return self.accountingLineViews[index].billingCycles.length + 1;
        } else {
          return 2;
        }
      };

      self.enableAccountTooltip = function(index) {
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.billingCyclesForRow = function(index, accountingLine) {
        if (self.isRowOpen(index)) {
          return _.find(self.accountingLineViews, {'accountingLine': accountingLine}).billingCycles;
        } else {
          return [_.find(self.accountingLineViews, {'accountingLine': accountingLine}).billingCycles[0]];
        }
      };

      self.showLockIcon = AccountListService.showLockIcon;

      self.getLockColor = AccountListService.getLockColor;

      self.getLockStatusToolTip = AccountListService.getLockStatusToolTip;

      self.hasBillingCycles = function(index) {
        return self.accountingLineViews[index].billingCycles.length > 0;
      };

      self.goToTransactionListForAccounting = function(accountingLineView, billingCycle) {

        if(!billingCycle) { return; }

        TransactionSearchModel.accountingLine(accountingLineView.accountingLine);

        BillingCycleModel.billingCycles(accountingLineView.billingCycles);

        TransactionSearchModel.billingCycle(billingCycle);

        $state.go('transactions', {currentRole: 'accountingManager'});
      };

      self.enableBillingCycleTransactionTooltip = function(index){
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.hasAccountingLineViews = function() {
        return !_.isEmpty(self.accountingLineViews);
      };

      self.getCurrencyFormat = UserModel.getCurrencyFormat;

    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/accountingManagerAccountsList.js
// module id = 427
// module chunks = 0